import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import MediaQuery from "cms/components/MediaQuery";
import OptimizedImage from "cms/components/OptimizedImage";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";

import {
  Container,
  Content,
  Illustration,
  Link,
  Message,
  Pitch,
} from "./LigmaHeroBannerBlock.styles";

export interface LigmaHeroBannerBlockProps
  extends Queries.SanityLigmaHeroBannerBlock {}

const LigmaHeroBannerBlock: React.FC<LigmaHeroBannerBlockProps> = ({
  headline,
  _rawPitch,
  button,
  image,
  imageAlt,
  imageMobile,
  imageMobileAlt,
}) => (
  <Container>
    <Content>
      <Message>
        <Text variant="H2" as="h1" color="#FFF">
          {headline}
        </Text>
        <Pitch>
          <RichText text={_rawPitch} variant="B3" />
        </Pitch>
        {button?.url && button.label && (
          <Link href={button.url}>
            <Button label={button.label} variant="primary" />
          </Link>
        )}
      </Message>

      <MediaQuery $lessThan="medium" style={{ width: "100%" }}>
        {imageMobile && (
          <Illustration>
            <OptimizedImage image={imageMobile} alt={imageMobileAlt} />
          </Illustration>
        )}
      </MediaQuery>

      <MediaQuery $greaterThan="medium" style={{ width: "100%" }}>
        {image && (
          <Illustration>
            <OptimizedImage image={image} alt={imageAlt} imageFit="cover" />
          </Illustration>
        )}
      </MediaQuery>
    </Content>
  </Container>
);

export const query = graphql`
  fragment LigmaHeroBannerBlock on SanityLigmaHeroBannerBlock {
    _key
    _type
    headline
    _rawPitch(resolveReferences: { maxDepth: 5 })
    button {
      variant
      label
      url
    }
    image { ...OptimizedImage }
    imageAlt
    imageMobile { ...OptimizedImage }
    imageMobileAlt
  }
`;

export default LigmaHeroBannerBlock;
